import { useCallback, useContext } from 'react';
import { AuthContext } from '../contexts/user-context/user-context';
import { API_ENDPOINT } from '../configurations/global.config';
import axios from 'axios';
import { DriverType } from '../interfaces/delivery-company/drivers';

interface UseDriversOptions {
  excludeDeleted?: boolean;
}

/**
 * Hook to fetch drivers from the API
 * Returns a function that can be used with AutocompleteWithThrottle
 */
export const useDrivers = (options: UseDriversOptions = {}) => {
  const { excludeDeleted = true } = options;
  const { config } = useContext(AuthContext);

  const fetchDrivers = useCallback(
    async (query: string): Promise<DriverType[]> => {
      const endpoint = `${API_ENDPOINT}/api/v1/drivers/?page_size=10&name_or_phone=${encodeURIComponent(query)}`;

      try {
        const response = await axios.get<{
          count: number;
          results: DriverType[];
        }>(endpoint, config);

        let drivers = response.data.results;

        if (excludeDeleted) {
          drivers = drivers.filter((driver) => !driver.is_deleted);
        }

        return drivers;
      } catch (error) {
        console.error('Failed to fetch drivers', error);
        return [];
      }
    },
    [config, excludeDeleted]
  );

  return { fetchDrivers };
};

